import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { Upload, Trash2, Copy } from "lucide-react";
import { api, absUrl } from "../../lib/api";
import { PageHeader, AdminBody, Card, Button } from "../../components/admin/Bits";

export default function Media() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef();

  const load = () => api.get("/admin/media").then(r => setRows(r.data));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    setBusy(true);
    try {
      for (const f of files) {
        const fd = new FormData(); fd.append("file", f);
        await api.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      }
      toast.success(`${files.length} file(s) uploaded`); load();
    } catch { toast.error("Upload failed"); } finally { setBusy(false); e.target.value = ""; }
  };

  const remove = async (r) => { if (!window.confirm("Delete?")) return; await api.delete(`/admin/media/${r.id}`); load(); };

  const copyUrl = (url) => { navigator.clipboard.writeText(absUrl(url)); toast.success("URL copied"); };

  return (
    <>
      <PageHeader title="Media Library" subtitle="All uploaded images & files."
        action={<>
          <input ref={fileRef} type="file" multiple className="hidden" onChange={upload} />
          <Button onClick={() => fileRef.current?.click()} disabled={busy} data-testid="media-upload">
            <Upload size={14} /> {busy ? "Uploading…" : "Upload Files"}
          </Button>
        </>} />
      <AdminBody>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {rows.map(m => (
            <div key={m.id} className="bg-white border border-navy-900/10 overflow-hidden group relative" data-testid={`media-${m.id}`}>
              <div className="aspect-square-card bg-ivory-200 flex items-center justify-center">
                <img src={absUrl(m.url)} alt={m.original_name} className="max-w-full max-h-full object-cover w-full h-full" />
              </div>
              <div className="p-2">
                <div className="text-[11px] truncate">{m.original_name}</div>
                <div className="text-[10px] text-navy-900/50">{(m.size / 1024).toFixed(0)} KB</div>
              </div>
              <div className="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition">
                <button onClick={() => copyUrl(m.url)} className="bg-navy-900 text-gold p-1.5"><Copy size={11} /></button>
                <button onClick={() => remove(m)} className="bg-maroon text-ivory p-1.5"><Trash2 size={11} /></button>
              </div>
            </div>
          ))}
          {rows.length === 0 && <Card className="col-span-full p-8 text-center text-navy-900/50">No media uploaded yet.</Card>}
        </div>
      </AdminBody>
    </>
  );
}
